import { createAsyncThunk } from '@reduxjs/toolkit';
import { securedAxiosInstance } from '../../../../api/axios';

export const getFolders = createAsyncThunk(
  'folders/getFolders',
  async (arg, { getState, rejectWithValue }) => {
    try {
      const response = await securedAxiosInstance.get(`/folders`);
      return response;
    } catch (error) {
      if (error.response && error.response.data.error) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const addFolder = createAsyncThunk(
  'folders/addFolder',
  async ({ formData }, { getState, rejectWithValue }) => {
    try {
      const response = await securedAxiosInstance.post(`/folders`, formData);

      return response;
    } catch (error) {
      if (error.response && error.response.data.error) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
export const updateFolder = createAsyncThunk(
  'folders/updateFolder',
  async ({ formData, id }, { getState, rejectWithValue }) => {
    try {
      const response = await securedAxiosInstance.put(
        `/folders/${id}`,
        formData
      );

      return response;
    } catch (error) {
      if (error.response && error.response.data.error) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
export const deleteFolder = createAsyncThunk(
  'folders/deleteFolder',
  async ({ id }, { getState, rejectWithValue }) => {
    try {
      const response = await securedAxiosInstance.delete(`/folders/${id}`);

      return response;
    } catch (error) {
      if (error.response && error.response.data.error) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
